const smoothScroll = () => {
  // Get the anchor ID and scroll to it
  const scrollToId = (link) => {
    let scrollMargin = 40;
    if (location.pathname.replace(/^\//,'') == link.pathname.replace(/^\//,'') || location.hostname == link.hostname ){
      const target = document.querySelector(link.hash),
            header = document.querySelector('#header');
      if (header) scrollMargin += header.clientHeight;
      if (target) {
        window.scrollTo({
          top: target.offsetTop - scrollMargin,
          behavior: 'smooth'
        });
      }
    }
  }

  // Click listeners
  const anchorsList = document.querySelectorAll('a[href^="#"]') || false;
  if (anchorsList) {
    [...anchorsList].forEach((anchor) => {
      anchor.addEventListener('click', (event) => {
        scrollToId(anchor);
        event.preventDefault();
        return false;
      });
    });
  }
}

smoothScroll();
